// src/context/YearContext.tsx
import React, { createContext, useContext, useState } from "react";

type YearContextType = {
  year: number;
  setYear: (y: number) => void;
};

const YearContext = createContext<YearContextType | undefined>(undefined);

export const YearProvider = ({ children }: { children: React.ReactNode }) => {
  const [year, setYear] = useState<number>(new Date().getFullYear());
  return <YearContext.Provider value={{ year, setYear }}>{children}</YearContext.Provider>;
};

export const useYear = (): YearContextType => {
  const ctx = useContext(YearContext);
  if (!ctx) throw new Error("useYear must be used inside YearProvider");
  return ctx;
};
